import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { JustinoService } from '../../../services/justino.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { Constants } from '../../../constants/constants';
import { JustinoControlAccesoService } from '../../../services/justino-control-acceso.service';

@Component({
  selector: 'app-consentimiento',
  templateUrl: './consentimiento.component.html',
  styleUrl: './consentimiento.component.scss'
})
export class ConsentimientoComponent implements OnInit {

  justinoActive = false;
  @Input() userID!: string;
  @Output() actualizar = new EventEmitter<void>();

  constructor(
    private router: Router,
    private justinoService: JustinoService,
    private alertService: AlertaModalService,
    private justinoControlAccesoService: JustinoControlAccesoService
  ) { }

  ngOnInit(): void {
    if (this.userID) {
      this.justinoControlAccesoService.checkAccess(this.userID).subscribe({
        next: (response: boolean) => {
          this.justinoActive = response;
        },
        error: (error) => {
          this.justinoActive = false;
        }
      });
    } else {
      this.justinoActive = false;
    }
  }

  onAceptar(): void {
    if (this.userID) {
      // Llamar al servicio controlAcceso
      this.justinoService.controlAcceso(this.userID).subscribe({
        next: (response) => {
          // Si la respuesta es 200, mostrar mensaje de confirmación
          this.alertService.exito('Consentimiento aceptado', 'El consentimiento se ha registrado correctamente')
            .then(() => {
              this.actualizar.emit();
            });
        },
        error: (error) => {
          // En caso de error, mostrar mensaje de error
          this.alertService.error('Error', 'Error al procesar el consentimiento');
        }
      });
    } else {
      this.actualizar.emit();
    }
  }

  onDeclinar(): void {
    // Redirigir a /tramites cuando se declina el consentimiento
    this.router.navigateByUrl(Constants.JUSTINO_RUTA_TRAMITES);
  }

}
